import { slicedToArray as _slicedToArray } from '../../_virtual/_rollupPluginBabelHelpers.js';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { t } from '../../i18n/translate.js';
import { getErrorMessage } from './errorHandler.js';
import { RssiStatus } from './RssiStatus/RssiStatus.js';
import { usePollInstallationErrors } from './UsePollInstallationErrors/usePollInstallationErrors.js';
import { useRssi } from './UseRssi/useRssi.js';
import { useIntervalTrigged } from './useIntervalTrigged.js';
import { InstallationErrorStatus } from './InstallationErrorStatus/InstallationErrorStatus.js';

var RssiComponent = function RssiComponent(_ref) {
  var giid = _ref.giid,
    deviceLabel = _ref.deviceLabel,
    onStateChanged = _ref.onStateChanged,
    onRssiMeasurementChanged = _ref.onRssiMeasurementChanged,
    nodeLoginWarningTimeout = _ref.nodeLoginWarningTimeout,
    client = _ref.client,
    measurementTypes = _ref.measurementTypes;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    nodeLoginWarning = _useState2[0],
    setNodeLoginWarning = _useState2[1];
  var _useRssi = useRssi(client, giid, deviceLabel, getErrorMessage(t), measurementTypes),
    startRssiScan = _useRssi.startRssiScan,
    startRssiTrigger = _useRssi.startRssiTrigger,
    rssiState = _useRssi.rssiState,
    stopRssiScan = _useRssi.stopRssiScan,
    rssiMeasurement = _useRssi.rssiMeasurement;
  var _usePollInstallationE = usePollInstallationErrors(client, giid, deviceLabel),
    startPollForInstallationErrors = _usePollInstallationE.startPoll,
    stopPollForInstallationErrors = _usePollInstallationE.stopPoll,
    deviceErrors = _usePollInstallationE.errors;
  var _useIntervalTrigged = useIntervalTrigged(function () {
      setNodeLoginWarning(t('MPLIB_EXTENDED_NODE_LOGIN_DESCRIPTION'));
      stopCountForNodeLogin();
    }, nodeLoginWarningTimeout),
    startCountForNodeLogin = _useIntervalTrigged.start,
    stopCountForNodeLogin = _useIntervalTrigged.stop;
  var isLoggedInToNode = function isLoggedInToNode(de) {
    return !(de !== null && de !== void 0 && de.some(function (err) {
      return err === 'NODE_LOGIN';
    }));
  };
  useEffect(function () {
    var errors = deviceErrors.errors,
      fatalErrors = deviceErrors.fatalErrors;
    if (fatalErrors && fatalErrors.length > 0) {
      stopPollForInstallationErrors();
      stopCountForNodeLogin();
    } else if (errors && isLoggedInToNode(errors)) {
      stopPollForInstallationErrors();
      stopCountForNodeLogin();
      startRssiTrigger();
      startRssiScan();
    }
  }, [deviceErrors]);
  useEffect(function () {
    onStateChanged(rssiState);
  }, [rssiState]);
  useEffect(function () {
    onRssiMeasurementChanged(rssiMeasurement);
  }, [rssiMeasurement]);
  useEffect(function () {
    startPollForInstallationErrors();
    startCountForNodeLogin();
  }, [startPollForInstallationErrors]);
  var cleanup = function cleanup() {
    stopCountForNodeLogin();
  };
  useEffect(cleanup, []);
  var noFatalErrors = deviceErrors.fatalErrors && deviceErrors.fatalErrors.length === 0;
  return isLoggedInToNode(deviceErrors.errors) && noFatalErrors ? /*#__PURE__*/React.createElement(RssiStatus, {
    t: t,
    rssiState: rssiState,
    startRssiScan: startRssiScan,
    stopRssiScan: stopRssiScan
  }) : /*#__PURE__*/React.createElement(InstallationErrorStatus, {
    t: t,
    fatalErrors: deviceErrors.fatalErrors,
    nodeLoginWarning: nodeLoginWarning
  });
};
RssiComponent.propTypes = {
  giid: PropTypes.string.isRequired,
  deviceLabel: PropTypes.string.isRequired,
  onStateChanged: PropTypes.func,
  onRssiMeasurementChanged: PropTypes.func,
  nodeLoginWarningTimeout: PropTypes.number,
  client: PropTypes.shape({
    query: PropTypes.func.isRequired,
    mutate: PropTypes.func.isRequired
  }).isRequired,
  measurementTypes: PropTypes.arrayOf(PropTypes.string)
};
RssiComponent.defaultProps = {
  onStateChanged: function onStateChanged() {},
  onRssiMeasurementChanged: function onRssiMeasurementChanged() {},
  nodeLoginWarningTimeout: 60 * 1000,
  measurementTypes: ['RADIO_RSSI']
};

export { RssiComponent as default };
